export default __webpack_public_path__ + "static/media/Ballroll_00079.0f8e125f.png";